//NEIGHBORHOOD list
export const NEIGHBORHOOD_LIST_REQUEST = 'NEIGHBORHOOD_LIST_REQUEST';
export const NEIGHBORHOOD_LIST_SUCCESS = 'NEIGHBORHOOD_LIST_SUCCESS';
export const NEIGHBORHOOD_LIST_FAIL = 'NEIGHBORHOOD_LIST_FAIL';
